<template>
    <div class="w-full pb-4 lg:w-max lg:pb-0">
        <div
            @click="$emit('toggle')"
            class="mb-5 flex cursor-pointer items-center justify-between border-b border-white pb-5 lg:pointer-events-none lg:border-none lg:pb-0">
            <span class="styled-as-h3 text-sm lg:text-xl">Contact</span>
            <IconChevronDown :class="{ '-rotate-180': open }" class="mr-5 size-4 lg:hidden" />
        </div>
        <nav
            class="overflow-hidden pl-5 duration-300 lg:pl-0"
            :class="{
                '!max-h-screen': open,
                '!max-h-0 lg:!max-h-full': !open,
            }">
            <ul class="flex flex-col gap-y-2">
                <li>
                    <NuxtLink
                        class="flex min-h-[44px] w-max items-center text-sm duration-200 hover:text-green-600"
                        target="_blank"
                        :to="formatPhoneNumberToLink(siteConfig.phone)">
                        <PhoneIcon class="mr-3 size-6 shrink-0" />
                        <span class="leading-none">{{ siteConfig.phone }}</span>
                    </NuxtLink>
                </li>
                <li>
                    <NuxtLink
                        class="group flex min-h-[44px] w-max items-center text-sm duration-200 hover:text-green-600"
                        target="_blank"
                        :to="formatWhatsappNumberToLink(siteConfig.whatsapp)">
                        <IconWhatsapp :aria-label="$snippets['headless.footer.whatsappAlt']" />
                        <span class="pl-4 leading-none">{{ $snippets['headless.footer.whatsapp'] }}</span>
                    </NuxtLink>
                </li>
                <li>
                    <NuxtLink
                        class="flex min-h-[44px] w-max items-center text-sm duration-200 hover:text-green-600"
                        target="_blank"
                        :to="'mailto:' + siteConfig.email">
                        <EnvelopeIcon class="mr-3 size-6 shrink-0" />
                        <span class="leading-none">{{ siteConfig.email }}</span>
                    </NuxtLink>
                </li>
                <li>
                    <NuxtLink
                        class="flex min-h-[44px] w-max items-center text-sm duration-200 hover:text-green-600"
                        :to="$snippets['headless.footer.openingsUrl']">
                        <ClockIcon class="mr-3 size-6 shrink-0" />
                        <span class="leading-none">{{ $snippets['headless.footer.openingHours'] }}</span>
                    </NuxtLink>
                </li>
                <li>
                    <NuxtLink
                        class="flex min-h-[44px] w-max items-center text-sm duration-200 hover:text-green-600"
                        target="_blank"
                        :to="
                            'https://www.google.com/maps/search/?api=1&query=' +
                            encodeURIComponent(siteConfig.address + ' ' + siteConfig.zipcode + ' ' + siteConfig.city)
                        ">
                        <MapPinIcon class="mr-3 size-6 shrink-0" />
                        <span class="leading-none">
                            <span class="mb-1.5 block">{{ siteConfig.address }}</span>
                            {{ siteConfig.zipcode }} {{ siteConfig.city }}
                        </span>
                    </NuxtLink>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script setup lang="ts">
    import { PhoneIcon, EnvelopeIcon, ClockIcon, MapPinIcon } from '@heroicons/vue/24/solid';

    defineProps<{
        siteConfig: {
            phone: string;
            whatsapp: string;
            email: string;
            address: string;
            zipcode: string;
            city: string;
            [key: string]: any;
        };
        open: boolean;
    }>();

    defineEmits<{
        toggle: [];
    }>();

    function formatPhoneNumberToLink(phoneNumber: string) {
        const cleanedNumber = phoneNumber.replace(/\s/g, '').replace(/-/g, '');
        return 'tel:' + cleanedNumber;
    }

    function formatWhatsappNumberToLink(whatsappNumber: string) {
        const cleanedNumber = whatsappNumber.replace(/\s/g, '');
        return 'https://wa.me/' + cleanedNumber;
    }
</script>
